import { httpRequest } from "../../../utils/HttpRequest";
import { IReceivableList, IReceivableSearch } from "./receivableTypes"
class Receivableservice {
    async receivable(params: IReceivableSearch) {
        const apiUrl = `/statement/receivable`;
        return await httpRequest.post<IReceivableList>(apiUrl, params);
    }
    async receivableExcel(params: IReceivableSearch) {
        const apiUrl = `/statement/receivableExcel`;
        return await httpRequest.postFile(apiUrl, params);
    }
}
export const receivableService = new Receivableservice();
